export const COMMON_PASSWORDS = [
  "password",
  "123456",
  "12345678",
  "qwerty",
  "abc123",
  "password123",
  "letmein",
];

export function validatePassword(password, userData = {}) {
  const checks = {
    length: password.length >= 8,
    uppercase: /[A-Z]/.test(password),
    lowercase: /[a-z]/.test(password),
    number: /[0-9]/.test(password),
    special: /[^A-Za-z0-9]/.test(password),
    noSpaces: !/\s/.test(password),
    notCommon: !COMMON_PASSWORDS.includes(password.toLowerCase()),
    notContainsName: userData.name
      ? !password.toLowerCase().includes(userData.name.toLowerCase())
      : true,
    notContainsEmail: userData.email
      ? !password.toLowerCase().includes(userData.email.split("@")[0])
      : true,
  };

  const score = Object.values(checks).filter(Boolean).length;

  let strength = "weak";
  if (score >= 6) strength = "strong";
  else if (score >= 6) strength = "medium";

  return {
    checks,
    score,
    strength,
  };
}
